export default {
    ordered: {
        error: {
            dependency_0001: "No se puede ordenar porque {name} está en el carrito | No se puede ordenar porque {name} está en el carrito",
            dependency_0002: "No se puede ordenar porque se ha ordenado {name} No se puede ordenar porque se ha ordenado {name}",
            cart: "No se puede realizar el pedido porque hay artículos del mismo tipo en el carrito"
        },
        type: {
            "ac_router": "Ya pedí un enrutador AC diferente",
            "chair": "Ya pedí una silla diferente",
            "default": "Ya lo ordené",
            "default_multiple": "Ya pedí productos similares",
            "desk": "Ya pedí un escritorio diferente",
            "desktop": "Ya pedí un escritorio diferente",
            "desktop_riser": "Ya pedí un elevador de escritorio diferente",
            "detector": "Ya pedí diferentes detectores de ruido y vaporizador.",
            "displayport_cable": "Ya pedí un cable DisplayPort diferente",
            "docking station": "Ya pedí una estación de acoplamiento diferente",
            "dual_usb_adapter": "Ya pedí un adaptador USB de doble banda diferente",
            "ear cushion": "Ya pedí unas almohadillas para los oídos diferentes",
            "footrest": "Ya pedí un reposapiés diferente",
            "hdmi_cable": "Ya pedí diferentes cables HDMI",
            "hdmi_displayport_cable": "Ya pedí un cable HDMI a DisplayPort diferente",
            "hdmi_vga_cable": "Ya pedí diferentes cables HDMI a VGA",
            "headset": "Ya pedí un dispositivo de audio diferente",
            "keyboard": "Ya pedí un teclado diferente",
            "kvm switch": "Ya pedí un conmutador KVM diferente",
            "kvm_switch": "Ya pedí un conmutador KVM diferente",
            "lamp": "Ya pedí una lámpara diferente",
            "laptop stand": "Ya pedí un soporte para portátil diferente",
            "laptop": "Ya pedí una computadora portátil diferente",
            "mesh_router": "Ya pedí un enrutador de malla diferente",
            "monitor": "Ya pedí un monitor diferente",
            "mouse": "Ya pedí diferentes ratones",
            "patch_cord": "Ya pedí un cable de conexión cat6 diferente",
            "power": "Ya pedí un cable de alimentación diferente",
            "power_center": "Ya pedí diferentes Power Center",
            "power_strip": "Ya pedí una regleta de enchufes diferente",
            "printer": "Ya pedí una impresora diferente",
            "smart_plug": "Ya pedí diferentes mini enchufes inteligentes",
            "smart_power_strip": "Ya pedí diferentes regletas de enchufes inteligentes",
            "speakerphone": "Ya pedí un altavoz diferente",
            "stylus": "Ya pedí un lápiz óptico diferente",
            "tablet": "Ya pedí una tableta diferente",
            "tablet accessory": "Ya pedí diferentes accesorios para tabletas.",
            "thunderbolt_cable": "Ya pedí un cable USB-C a Thunderbolt diferente",
            "travel_router": "Ya pedí un enrutador de viaje diferente",
            "usb hub": "Ya pedí un concentrador USB diferente",
            "usb_adapter": "Ya pedí un adaptador USB diferente",
            "usb_hub": "Ya pedí un concentrador diferente",
            "webcam": "Ya pedí una cámara web diferente"
        },
        product: "Ordenado"
    },
    request: "Pedido",
    add: "Añadir a la cesta",
    remove: "Quitar del carrito",
    added: "Añadido al carrito",
    view: "Ver artículo"
}